import { useQuery } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../api/v1";
import { ApiResponse } from "../../../../../types/api-response";
import { TemplateField } from "../../../../../types/template";
import axios from "../../../../../utils/axiosInceptor";

export type Category = {
  categoryId: string;
  categoryName: string;
  serviceType: string;
  paid: boolean;
  amount: number;
  amountWithVat: number;
  vat: number;
  position: number;
  isEnabled: boolean;
  template: TemplateField[];
  subCategories?: unknown[];
};

type GeneralService = {
  orgId: string;
  combinationName: string;
  residentialCategories: Category[];
  commercialCategories: Category[];
  internalCategories: Category[];
  createdAt: string;
  updatedAt?: string;
};

type UseGetGeneralServicesOptions = {
  isEnabled?: boolean;
};

const getGeneralServices = async () => {
  const url = `${apiV1Endpoint}/general-services`;
  const response = await axios.get<ApiResponse<GeneralService>>(url);
  return response.data.result;
};

export const useGetGeneralServices = (options: UseGetGeneralServicesOptions = {}) => {
  const { isEnabled } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["general-services"],
    queryFn: getGeneralServices,
    enabled: isEnabled,
  });

  return { generalServices: data, isLoadingGeneralServices: isLoading };
};
